// extracted by mini-css-extract-plugin
module.exports = {"dot":"dot-3LQaHUbT","current":"current-JhT3FZKL dot-3LQaHUbT"};